import { Box, Typography, Divider } from "@material-ui/core";
import React from "react";
import CircleIcon from "@mui/icons-material/Circle";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

function Legend() {
  return (
    <Box
      className="legend"
      style={{
        position: "absolute",
        top: "180px",
        right: "40px",
        padding: "10px",
        display: "none",
        zIndex: 1000, // Ensure the legend is displayed above the map content
      }}
    >
      <Box display="flex" flexDirection="row">
        <Typography variant="h5">Natural Gas Processing Facility</Typography>
        <Box sx={{ marginLeft: "15px" }}>
          <CircleIcon className={`${process.env.REACT_APP_STOCK}-legend`} />
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flexDirection="row">
        <Typography variant="h5">Gathering Pipeline</Typography>
        <Box
          sx={{
            marginLeft: {
              xs: "81px",
              sm: "99px",
            },
          }}
        >
          <HorizontalRuleIcon
            sx={{
              color: `${
                process.env.REACT_APP_GEOJSON_PIPELINES_COLOR || "#5C9979"
              }`,
            }}
          />
        </Box>
      </Box>
      <Divider />
    </Box>
  );
}

export default Legend;
